
export default function (Component) {
  Component.options.__source = "src/components/aboutForm/dialogForm.vue"
}
